<ng-content select="[content-before]" />

@let sections = menusLocal();

@if (sections.length > 0) {
  <nav
    class="navigation"
    data-testid="nav-secondary">
    @for (section of sections; track sectionIndex; let sectionIndex = $index) {
      @if (sectionIndex > 0 && sectionIndex < sections.length) {
        <div class="navigation__divider"></div>
      }
      @if (section.title) {
        <div class="title _expanded">{{ section.title | optionalAsync }}</div>
      }
      @let badgeItems = section.badgeItems ? section.badgeItems() : [];
      @if (badgeItems.length) {
        @let currentOrganizationItem = getCurrentOrganizationWithInlineRoles(badgeItems);

        @if (currentOrganizationItem) {
          <evc-badge-button
            trigger
            evcMenuTriggerState
            class="leftbar__badge _expanded"
            [currentText]="currentOrganizationItem.name"
            [avatar]="currentOrganizationItem.avatar"
            [additionalText]="currentOrganizationItem.roles" />
        }
      }
      @for (item of section.items; track item.key) {
        <button
          class="item"
          [attr.data-testid]="item.key"
          [attr.data-selected]="item.selected"
          [disabled]="item.isDisabled"
          [evcTooltipHover]="item.text"
          [evcTooltipVisible]="showTooltip()"
          (click)="handleItemClick(item)">
          <evc-icon
            size="md"
            [icon]="getItemIcon(item)" />
          <span
            class="item__text"
            [attr.data-collapsed]="collapsed() && isLeftbarHost()">
            {{ item.text | optionalAsync }}
          </span>
        </button>
      }
    }
  </nav>
}

<ng-content select="[content-after]" />
